import { useQuery } from "@tanstack/react-query";
import api from "../../api/apiClient";
import { OpeningHoursWithInheritance } from "../../types/modules/opening-hours.type";
import { getStoreId } from "../../utils/auth";

export const useCategoryOpeningHours = (
    storeId: number | undefined,
    categoryId: number | undefined,
    enabled: boolean = true,
) => {
    const resolvedStoreId = storeId ?? getStoreId();

    return useQuery({
        queryKey: [
            "category-opening-hours",
            resolvedStoreId,
            categoryId,
        ],
        queryFn: () =>
            api
                .get<OpeningHoursWithInheritance>(
                    `category-opening-hours/current/${categoryId}?storeId=${resolvedStoreId}`,
                )
                .then((res) => res.data),
        enabled:
            enabled &&
            !!resolvedStoreId &&
            !!categoryId,
    });
};